import { Alert, Button, Text } from '@/ui'
import { faPencil, faSync } from '@fortawesome/pro-light-svg-icons'
import { useMemo, useState } from 'react'
import { TextColors, TypographyStyles } from '@/styles'
import { TransactionDeleteModal } from '@/features/transactions/TransactionDeleteModal'

export const DetailsAlert = ({
  isUserManualTransaction,
  isManualTransaction,
  transactionId,
  isReconciled,
}: {
  isUserManualTransaction: boolean
  isManualTransaction: boolean
  transactionId: number
  isReconciled: boolean
}) => {
  const [open, setOpen] = useState(false)

  const content = useMemo(() => {
    if (isUserManualTransaction) {
      return {
        icon: faPencil,
        body: 'Manually added transaction',
        button: 'Delete',
      }
    } else if (!isUserManualTransaction && isManualTransaction) {
      return {
        icon: faSync,
        body: 'Manually added by Heard',
        button: 'Mark as Duplicate',
      }
    } else {
      return {
        icon: faSync,
        body: 'Synced transaction',
        button: 'Mark as Duplicate',
      }
    }
  }, [isUserManualTransaction, isManualTransaction])

  return (
    <Alert customIconName={content.icon} variant="default" className="mb-4">
      <div className="flex flex-col">
        {(!isReconciled || !isUserManualTransaction) && (
          <div className="flex flex-row justify-between items-center">
            <Text variant={TypographyStyles.BODY_SM} className="w-5/8">
              {content.body}
            </Text>

            <div className="w-3/8">
              <Button
                className="w-full h-full"
                variant="link"
                onClick={() => setOpen(true)}
              >
                <Text
                  color={
                    isUserManualTransaction
                      ? TextColors.RED
                      : TextColors.DEFAULT
                  }
                  variant={TypographyStyles.BODY_XS}
                >
                  {content.button}
                </Text>
              </Button>
            </div>
          </div>
        )}
        {isReconciled && isUserManualTransaction && (
          <Text variant={TypographyStyles.BODY_SM} className="w-full">
            {content.body}
          </Text>
        )}
      </div>
      {open && (
        <TransactionDeleteModal
          open={open}
          close={() => setOpen(false)}
          transactionId={transactionId}
          isManualTransaction={isUserManualTransaction}
        />
      )}
    </Alert>
  )
}
